// Global
import React from 'react';

// Local
import { ProductDetail } from './ProductDetail';
import { ProductResponse } from 'lib/services/models/content-response';
import { useBreadcrumbData } from 'lib/hooks/useBreadcrumbData';
import { useContentItem } from 'lib/hooks/useContentItem';
import { useSiteSettings } from 'lib/hooks/useSiteSettings';
import { useSitecorePage } from 'lib/hooks/sitecore/useSitecorePage';

function ProductDetailWrapper() {
  const contentItem = useContentItem();
  const breadcrumbData = useBreadcrumbData();
  const siteSettings = useSiteSettings();
  const productResponse = contentItem as ProductResponse;
  const productRouteDetails = useSitecorePage();

  return (
    <ProductDetail
      product={productResponse}
      siteSettings={siteSettings}
      productRouteDetails={productRouteDetails}
      breadcrumbData={breadcrumbData?.ancestors}
    />
  );
}

export const Default = ProductDetailWrapper;
